import React, {useEffect, useRef, useState} from 'react';
import './SearchLocationInput.scss';
import {withTranslation} from 'react-i18next';

const GOOGLE_API_KEY = 'AIzaSyCbGCUYrMZYj-LdlsRJIeHg60ekgDPwczw';

let autoComplete;

const loadScript = (url, callback) => {
  let script = document.createElement('script');
  script.type = 'text/javascript';

  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = () => callback();
  }

  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
};

function handleScriptLoad(updateQuery, autoCompleteRef, selectAddress, setError) {
  autoComplete = new window.google.maps.places.Autocomplete(
    autoCompleteRef.current,
    {types: ['geocode'], componentRestrictions: {country: 'il'}}
  );
  autoComplete.setFields(['place_id', 'formatted_address', 'geometry', 'address_components']);
  autoComplete.addListener('place_changed', () =>
    handlePlaceSelect(updateQuery, selectAddress, setError)
  );
}

async function handlePlaceSelect(updateQuery, selectAddress, setError) {
  const addressObject = autoComplete.getPlace();
  if (!addressObject) {
    setError('required');
    return;
  }
  const streetPresent = containsStreetNumber(addressObject);
  const query = addressObject.formatted_address;
  updateQuery(query);
  if (!streetPresent) {
    setError('empty_street');
    selectAddress(null);
  } else {
    setError(null);
    selectAddress(addressObject);
  }

  console.log(addressObject);
}

function containsStreetNumber(addressObject) {
  let result = false;
  for (const component of addressObject.address_components) {
    const addressType = component.types[0];

    if (addressType === 'street_number') {
      result = true;
    }
  }

  return result;
}

const SearchLocationInput = ({defaultValue = '', addressObject = null, placeholder, language, onAddressSelect, t, onError}) => {
  const [query, setQuery] = useState(defaultValue);
  const [selectedAddress, setSelectedAddress] = useState(addressObject);
  const autoCompleteRef = useRef(null);
  const [error, setError] = useState(null);
  const ERRORS = {
    'empty_street': t('client_details.validation.street_is_empty'),
    'required': t('client_details.validation.required_field')
  };

  const selectAddress = (addressObject) => {
    onAddressSelect(addressObject);
    setSelectedAddress(addressObject);
  };

  const onChaangeAddressText = (e) => {
    e.stopPropagation();
    const {value} = e.currentTarget;
    setQuery(value);
    if (value === '') {
      selectAddress(null);
      setError('required');
    }
  };

  useEffect(() => {
    loadScript(
      `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&language=he&libraries=places`,
      () => handleScriptLoad(setQuery, autoCompleteRef, selectAddress, setError)
    );
  }, [language]);

  useEffect(() => {
    if (!selectedAddress) {
      setError('required');
    }
  }, []);

  useEffect(() => {
    if (onError) {
      onError(ERRORS[error]);
    }
  }, [error]);

  return (
    <div className="search-location-input">
      <input
        ref={ autoCompleteRef }
        onChange={ onChaangeAddressText }
        placeholder={ placeholder }
        value={ query }
        autoComplete={ 'off' }
      />

      {error &&
        <div className={ 'input-error' }>
          <span>{ERRORS[error]}</span>
        </div>
      }
    </div>
  );
};

export default withTranslation()(SearchLocationInput);
